module.exports = __webpack_public_path__ + "img/welcome.fbf3168f.png";